/**
 * Whether this tab has a call up — readable from code that must not import the
 * voip store.
 *
 * The session-expiry path lives under the API client, and the voip store
 * imports the API client, so the client cannot ask the store directly. The
 * store writes this flag on every change; the session code reads it. No
 * imports, so nothing here can close a cycle.
 *
 * A ringing call counts. An agent who is about to answer must not be signed
 * out from under the ring any more than one already talking.
 */

let inFlight = false;
const waiters = new Set<() => void>();

export function setCallsInFlight(next: boolean): void {
  inFlight = next;
  if (next) return;
  const ready = [...waiters];
  waiters.clear();
  for (const run of ready) run();
}

export function hasCallsInFlight(): boolean {
  return inFlight;
}

/** Run `fn` once no call is up — now, if none is. */
export function whenNoCallsInFlight(fn: () => void): void {
  if (!inFlight) {
    fn();
    return;
  }
  waiters.add(fn);
}
